module.exports = __webpack_public_path__ + "static/media/BackgroundZedblox.cc9839f5.png";